/*
 * Every tap target here — the month arrows and the days — is at least 44×44 px on a phone
 * (BUG-19: days were 39×39 and arrows 32×32, and a thumb that missed by one day changed the
 * range and the price). The grid does not shrink under 44 per column; on a narrow screen the
 * calendar reclaims the padding around it instead of shrinking the days.
 */
.calendar {
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.navBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--gac-control-touch-target);
  height: var(--gac-control-touch-target);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
  cursor: pointer;
}

.navBtn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(44px, 1fr));
  gap: 2px;
}

.weekday {
  padding: 4px 0;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.55);
}

.day {
  aspect-ratio: 1;
  min-width: var(--gac-control-touch-target);
  min-height: var(--gac-control-touch-target);
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: white;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}

.day:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
}

.dayPast {
  color: rgba(255, 255, 255, 0.25);
  cursor: not-allowed;
}

.dayOccupied {
  color: rgba(255, 255, 255, 0.35);
  background: rgba(255, 60, 60, 0.14);
  text-decoration: line-through;
  cursor: not-allowed;
}

.dayEdge {
  background: #ccff00;
  color: #111;
  font-weight: 700;
}

.dayEdge:hover:not(:disabled) {
  background: #ccff00;
}

.dayInRange {
  background: rgba(204, 255, 0, 0.22);
}

.legend {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.legendSwatch {
  width: 12px;
  height: 12px;
  border-radius: 4px;
  flex-shrink: 0;
}

.legendOccupied {
  background: rgba(255, 60, 60, 0.35);
}

/* 7 × 44 + 6 × 2 = 320 px of grid. A 375 px phone leaves ~285 px inside the screen's own
   padding, so the calendar steps out of that padding and thins its own to fit the days. */
@media (max-width: 420px) {
  .calendar {
    padding: 8px 4px;
    margin: 0 -16px;
    width: auto;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }

  .header {
    padding: 0 4px;
  }
}

/* The narrowest phones (320 px) have 288 px for the grid: let the days shrink to 40 rather than
   overflow the card sideways. */
@media (max-width: 340px) {
  .grid {
    grid-template-columns: repeat(7, minmax(40px, 1fr));
  }

  .day {
    min-width: 40px;
    min-height: 40px;
  }
}
